export const UPDATE_COLUMN_CONFIG_REQUEST = 'UPDATE_COLUMN_CONFIG_REQUEST';

export const updateColumnConfigRequest = (tableEntryId, columnConfig) => ({
  type: UPDATE_COLUMN_CONFIG_REQUEST,
  payload: {
    tableEntryId,
    columnConfig
  }
});
